import { TranslationObject } from '../i18n/translation';

const getCookiesText = (nb: boolean = true) =>
  nb
    ? '<p>Bruk av informasjonskapsler er regulert i <a href="https://lovdata.no/dokument/NL/lov/2003-07-04-83">ekomloven § 2-7b</a>. Bruk av informasjonskapsler er ikke tillatt med mindre bruker er informert om, og har samtykket til:</p>' +
      '<ul>' +
      '<li>hvilke opplysninger som behandles</li>' +
      '<li>hva formålet er med denne behandlingen</li>' +
      '<li>hvem som behandler opplysningene</li>' +
      '</ul>' +
      '<p>Ved å godta bruk av informasjonskapsler samtykkes det til at Sikt kan sammenstille informasjon om bruk av direktoratets tjenester med data fra andre kilder.</p>' +
      '<h3>Hva bør jeg vite om informasjonskapsler (cookies)?</h3>' +
      '<p>Informasjonskapsler er små tekstfiler som nettstedet lagrer på brukerens datamaskin/enhet. Filene kan kun leses av deg og nettstedet eller applikasjonen.</p>' +
      '<p>Informasjonskapslene kan inneholde personopplysninger. Du kan hindre at informasjonskapsler lagres ved å endre innstillingene i nettleseren.</p>' +
      '<h3>Hva bruker Sikt informasjonskapsler (cookies) til, og hvorfor?</h3>' +
      '<p>Sikt bruker informasjonskapsler til å:</p>' +
      '<ul>' +
      '<li>se om brukeren har besøkt nettstedet tidligere, tidspunktet for besøket og hvilket nettsted brukeren kom fra</li>' +
      '<li>analysere det generelle brukermønsteret</li>' +
      '<li>hjelpe oss forstå hvordan arbeidslivsportalen.no og direktoratets øvrige tjenester brukes, for videreutvikling og å forbedre veiledning</li>' +
      '</ul>'
    : '<p>The use of cookies is regulated by the <a href="https://lovdata.no/dokument/NL/lov/2003-07-04-83">Electronic Communications Act §2-7b (in Norwegian)</a>. The use of cookies is not permitted unless the user has been informed and has agreed to the following:</p>' +
      '<ul>' +
      '<li>what information is being processed</li>' +
      '<li>the purpose of processing this information</li>' +
      '<li>who processes the information</li>' +
      '</ul>' +
      '<p>By consenting to cookies on the Arbeidslivsportalen web site, you are consenting to compilation of information about usage of the directorate’s services from other sources.</p>' +
      '<h3>What do I need to know about cookies?</h3>' +
      '<p>Cookies are small text files which are transferred to your computer or mobile when you visit a website or app. These files can only be read by you and that website or app. </p>' +
      '<p>Cookies may include personal data. You can also stop your browser from tracking your information by changing your browser settings.</p>' +
      '<h3>How does Sikt/Arbeidslivsportalen use cookies?</h3>' +
      '<p>Sikt uses cookies to:</p>' +
      '<ul>' +
      '<li>see if users have previously visited the website, at what time, and what website reffered the user</li>' +
      '<li>analyze Arbeidslivsportalen’s general usage patterns and statistics</li>' +
      '<li>help us understand how people are using arbeidslivsportalen.no and the directorate’s other services, so we can make them better</li>' +
      '</ul>';

const translations: TranslationObject = {
  title: {
    id: 'welcome.title',
    nb: 'Arbeidslivsportalen',
    en: 'Arbeidslivsportalen',
  },
  omTjenesten: {
    id: 'welcome.omTjenesten',
    nb: 'Om tjenesten',
    en: 'About',
  },
  description: {
    id: 'welcome.description',
    nb: 'En samhandlingsplattform mellom utdanning og arbeidslivet.',
    en: 'A collaboration platform between education and working life.',
  },
  feide1: {
    id: 'welcome.feide1',
    nb: 'Logg inn med Feide',
    en: 'Log in using Feide',
  },
  feide2: {
    id: 'welcome.feide2',
    nb: 'Feide er Kunnskapsdepartementets valgte løsning for sikker identifisering i utdanningssektoren.',
    en: "Feide is the Ministry of Education's chosen solution for secure identification in the education sector",
  },
  idporten1: {
    id: 'welcome.idporten1',
    nb: 'Logg inn med ID-Porten',
    en: 'Log in using ID-Porten',
  },
  idporten2: {
    id: 'welcome.idporten2',
    nb: 'ID-porten er en innloggingsløsning levert av Digitaliseringsdirektoratet (Digdir) som tilbyr sikker innlogging gjennom elektronisk ID (e-ID) fra MinID, BankID, Buypass og Commfides.',
    en: 'ID-porten is a login solution provided by Digdir that offers secure login through electronic ID (e-ID) from MinID, BankID, Buypass and Commfides',
  },
  loggedOutMsg: {
    id: 'welcome.loggedOutMsg',
    nb: 'Du har blitt logget ut på grunn av inaktivitet',
    en: 'You were logged out due to inactivity',
  },
  pageTitle: {
    id: 'welcome.pageTitle',
    nb: 'Innlogging',
    en: 'Innlogging',
  },
  rightsAndPrivacy: {
    id: 'welcome.rightsAndPrivacy',
    nb: 'Rettigheter og personvern',
    en: 'Rights and privacy',
  },
  aboutCookiesTitle: {
    id: 'welcome.aboutCookiesTitle',
    nb: 'Bruk av informasjonskapsler/cookies',
    en: 'Cookies',
  },
  aboutCookiesText: {
    id: 'welcome.aboutCookiesText',
    nb: getCookiesText(),
    en: getCookiesText(false),
  },
  aboutAnalyticsTitle: {
    id: 'welcome.aboutAnalyticsTitle',
    nb: 'Analyseverktøy for webstatistikk',
    en: 'Analytical tools for web statistics',
  },
  aboutAnalyticsText: {
    id: 'welcome.aboutAnalyticsText',
    nb: '<p>Arbeidslivsportalen henter inn informasjon for å vurdere hvordan besøkende bruker nettstedet.</p>',
    en: '<p>Arbeidslivsportalen gathers information to analyze how the portal is used.</p>',
  },
  accessibilityStatement: {
    id: 'welcome.accessibilityStatement',
    nb: 'Tilgjengelighetserklæring',
    en: 'Accessibility statement (Norwegian)',
  },
  aboutTitle: {
    id: 'welcome.aboutTitle',
    nb: 'Rettigheter og personvern',
    en: 'Rights and privacy',
  },
  idportenHelpText: {
    id: 'welcome.idportenHelpText',
    nb: 'For alle brukere',
    en: 'Usable by all users',
  },
  feideHelpText: {
    id: 'welcome.feideHelpText',
    nb: 'For studiestedbrukere og studenter',
    en: 'For faculty users and students ',
  },
};

export default translations;
